import { useGuia } from './useGuia'
import { IconoDuda } from '../componentes/iconos'

/**
 * Botón «Guía» del header. Lanza el tour de la pantalla actual si existe
 * (p.ej. Logística, Gestión, Grandes Empresas); si no, el recorrido general.
 * El tour global siempre es accesible desde el paso final de cada guía y con
 * pulsación larga no: aquí priorizamos la ayuda contextual de la pantalla.
 *
 * `soloIcono` lo compacta para la cabecera móvil (igual que la campana).
 */
export function BotonGuia({ soloIcono = false }: { soloIcono?: boolean }) {
  const { lanzarDePantalla, hayTourDePantalla } = useGuia()

  if (soloIcono) {
    return (
      <button
        type="button"
        data-tour="guia"
        onClick={lanzarDePantalla}
        aria-label="Abrir la guía de esta pantalla"
        className="flex size-10 items-center justify-center rounded-lg border border-borde-fuerte bg-superficie text-tinta-2 transition-colors hover:bg-elevado hover:text-tinta"
      >
        <IconoDuda className="size-5" />
      </button>
    )
  }

  return (
    <button
      type="button"
      data-tour="guia"
      onClick={lanzarDePantalla}
      aria-label="Abrir la guía"
      title={hayTourDePantalla ? 'Guía de esta pantalla' : 'Recorrido general'}
      className="flex items-center gap-2 rounded-lg border border-acento-borde bg-acento-suave px-3 py-2 text-sm font-semibold text-acento-tinta transition-colors hover:brightness-110"
    >
      <IconoDuda className="size-5 shrink-0" />
      <span className="hidden lg:inline">Guía</span>
    </button>
  )
}
